// Wording for the chip "Add" button. Beside the editor rather than in it,
// so the editor file exports a component and nothing else.

/**
 * Label for the chip "Add" button — the mockup words it after the field itself
 * ("Add badge" for `badges`), so a plural key drops its trailing "s". Endings
 * that are not a plural marker (`status`, `progress`, `axis`) are left alone;
 * this is a display nicety, not a general-purpose singulariser.
 */
export function addLabelFor(key: string): string {
  if (!key) return "value";
  if (/(ss|us|is)$/.test(key)) return key;
  if (key.endsWith("s")) return key.slice(0, -1);
  return key;
}
